import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useCartStore from '../utils/cartStore';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const items = useCartStore((state) => state.items);
  
  const cartCount = items.reduce((total, item) => total + item.quantity, 0);

  const scrollToProducts = () => {
    if (window.location.pathname === '/') {
      const section = document.getElementById('products');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = '/#products';
    }
  };

  const menuItems = [
    { name: 'Accueil', path: '/' },
    { name: 'Notre Histoire', path: '/about' },
    { 
      name: 'Nos Produits', 
      path: '/',
      onClick: () => scrollToProducts()
    },
    { name: 'Comment commander ?', path: '/comment-commander' },
    { name: 'Événements', path: '/events' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-lg">
      <div className="container-custom">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <span className="text-2xl font-playfair font-bold text-primary hidden md:block">
              PÉTALES DE DOUCEUR
            </span>
            <span className="text-2xl font-playfair font-bold text-primary md:hidden">
              PÉTALES DE DOUCEUR
            </span>
          </Link>

          {/* Navigation Desktop */}
          <nav className="hidden md:flex items-center space-x-8">
            {menuItems.map((item, index) => (
              item.onClick ? (
                <button
                  key={index}
                  onClick={item.onClick}
                  className="text-dark hover:text-primary font-medium transition-colors duration-300"
                >
                  {item.name}
                </button>
              ) : (
                <Link
                  key={index}
                  to={item.path}
                  className="text-dark hover:text-primary font-medium transition-colors duration-300"
                >
                  {item.name}
                </Link>
              )
            ))}
          </nav>

          {/* Social Icons & Cart */}
          <div className="flex items-center space-x-6">
            <div className="hidden md:flex items-center space-x-4">
              <a 
                href="https://www.facebook.com/people/Petales-Dedouceur/61576262167502/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-dark hover:text-primary transition-colors duration-300"
              >
                <i className="fab fa-facebook text-xl"></i>
              </a>
              <a 
                href="https://www.instagram.com/petales_de_douceur/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-dark hover:text-primary transition-colors duration-300"
              >
                <i className="fab fa-instagram text-xl"></i>
              </a>
            </div>

            {/* Cart */}
            <Link to="/cart" className="relative">
              <i className="fas fa-shopping-basket text-xl text-dark hover:text-primary transition-colors duration-300"></i>
              <span className="absolute -top-2 -right-2 bg-primary text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {cartCount}
              </span>
            </Link>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-2xl text-dark"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white py-4 border-t animate-fade-in">
            <div className="flex flex-col space-y-4">
              {menuItems.map((item, index) => (
                item.onClick ? (
                  <button
                    key={index}
                    onClick={() => {
                      item.onClick();
                      setIsMenuOpen(false);
                    }}
                    className="text-dark hover:text-primary font-medium text-lg py-2 text-left"
                  >
                    {item.name}
                  </button>
                ) : (
                  <Link
                    key={index}
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className="text-dark hover:text-primary font-medium text-lg py-2"
                  >
                    {item.name}
                  </Link>
                )
              ))}
              <div className="flex space-x-6 pt-4">
                <a href="https://www.facebook.com/people/Petales-Dedouceur/61576262167502/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook text-2xl text-dark hover:text-primary"></i>
                </a>
                <a href="https://www.instagram.com/petales_de_douceur/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram text-2xl text-dark hover:text-primary"></i>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;